export const SET_APP_CONFIG = 'SET_APP_CONFIG';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_COURSES_BALANCE = 'SET_USER_COURSES_BALANCE';
export const SET_TERMS = 'SET_TERMS';

// User
export const SET_AMOUNTS = 'SET_AMOUNTS';
export const SET_USER_BALANCE = 'SET_USER_BALANCE';
export const SET_CURRENT_USER_BALANCE = 'SET_CURRENT_USER_BALANCE';
export const DECREMENT_COIN = 'DECREMENT_COIN';
export const TOGGLE_CREATORS_AREA_BANNER = 'TOGGLE_CREATORS_AREA_BANNER';

// Cuorse
export const SET_COURSES = 'SET_COURSES';
export const SET_PURCHASED_COURSES = 'SET_PURCHASED_COURSES';
export const SET_FAVORITES_COURSES = 'SET_FAVORITES_COURSES';
export const SET_SEARCH_COURSES = 'SET_SEARCH_COURSES';
export const SET_COURSE = 'SET_COURSE';
export const SET_VIEW_COURSE = 'SET_VIEW_COURSE';
